export default function labeltop(event) {
    event.target.removeAttribute('readonly')
    const superparent = event.target.parentElement;
    superparent.classList.add('top');
}